(function () {
  function redirectToCartPage() {
    window.location.href = window.routes?.cart_url || `${window.shopUrl || ''}/cart`;
  }

  function stickyAtcDirectAdd(trigger, form) {
    const variantInput = form?.querySelector('input[name="id"]');
    const variantId = variantInput?.value;
    if (!variantId || !trigger) return;

    trigger.disabled = true;
    trigger.setAttribute('aria-disabled', 'true');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(trigger);
      }
    }

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then((r) => r.json())
      .then((data) => {
        if (data.status) {
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = data.description || window.cartStrings?.error || '';
          return;
        }

        redirectToCartPage();
      })
      .catch(() => {
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings?.error || '';
      })
      .finally(() => {
        trigger.disabled = false;
        trigger.removeAttribute('aria-disabled');
      });
  }

  function ensureVariantPopupsBound() {
    if (typeof window.initProductVariantPopups === 'function') {
      window.initProductVariantPopups();
    } else if (typeof window.initCartUpsellPopups === 'function') {
      window.initCartUpsellPopups();
    }
  }

  function openStickyVariantPopup(wrapper) {
    const popup = wrapper?.querySelector('[data-cart-upsell-variant-popup]');
    if (!popup) return false;

    ensureVariantPopupsBound();

    if (typeof popup.openVariantPopup === 'function') {
      popup.openVariantPopup();
      return true;
    }

    const dialog = popup.querySelector('[data-variant-popup-dialog]');
    const fieldset = popup.querySelector('[data-variant-popup-fieldset]');
    if (!dialog || !fieldset || dialog.hidden === false) return false;

    const mount = popup.querySelector('[data-fieldset-mount]');
    if (mount && fieldset.parentElement !== mount) {
      mount.appendChild(fieldset);
    }

    dialog.hidden = false;
    document.documentElement.classList.add('variant-popup-open', 'variant-popup-open--preserve-scroll');

    return true;
  }

  function initGlobalStickyAtc(bar) {
    const trigger = bar.querySelector('[data-sticky-atc-trigger]');
    const labelEl = bar.querySelector('[data-sticky-atc-label]');
    const wrapper = bar.closest('[data-global-sticky-atc]');
    const form = wrapper?.querySelector('[data-cart-upsell-form]');
    const customLabel = bar.dataset.stickyAtcLabel || '';
    const isVariantPopup = bar.dataset.stickyAtcVariantPopup === 'true';

    bar.removeAttribute('hidden');
    document.body.classList.add('sticky-atc-bar-visible');

    if (labelEl && customLabel) {
      labelEl.textContent = customLabel;
    }

    if (isVariantPopup) {
      ensureVariantPopupsBound();
    }

    if (!trigger) return;

    trigger.addEventListener('click', () => {
      if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;

      if (isVariantPopup) {
        openStickyVariantPopup(wrapper);
        return;
      }

      stickyAtcDirectAdd(trigger, form);
    });
  }

  function initProductStickyAtc() {
    const bars = document.querySelectorAll('[data-sticky-atc]');
    if (!bars.length) return;

    bars.forEach((bar) => {
      if (bar.closest('quick-add-modal')) return;

      if (bar.dataset.stickyAtcGlobal === 'true') {
        initGlobalStickyAtc(bar);
        return;
      }

      const sectionId = bar.dataset.sectionId;
      if (!sectionId) return;

      const productInfo = bar.closest('product-info');
      const priceSource = document.getElementById(`price-${sectionId}`);
      const priceTarget = bar.querySelector('[data-sticky-atc-price]');
      const trigger = bar.querySelector('[data-sticky-atc-trigger]');
      const labelEl = bar.querySelector('[data-sticky-atc-label]');
      const img = bar.querySelector('[data-sticky-atc-img]');
      const mainSubmit = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const fallbackSrc = bar.dataset.fallbackSrc || '';

      const syncPrice = () => {
        if (!priceSource || !priceTarget) return;
        priceTarget.innerHTML = priceSource.innerHTML;
      };

      const customLabel = bar.dataset.stickyAtcLabel || '';
      const isVariantPopup = bar.dataset.stickyAtcVariantPopup === 'true';

      const syncButton = () => {
        if (!mainSubmit || !trigger || !labelEl) return;
        const mainSpan = mainSubmit.querySelector('span');
        const isDisabled = mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true';
        trigger.disabled = isDisabled;
        if (mainSpan && mainSpan.textContent.trim()) {
          if (customLabel && !isDisabled) {
            labelEl.textContent = customLabel;
          } else {
            labelEl.textContent = mainSpan.textContent.trim();
          }
        }
      };

      const setImageFromVariant = (variant) => {
        if (!img) return;
        const fi = variant?.featured_image;
        const url = fi?.src || fi?.url;
        if (url) {
          img.src = url;
          if (fi.alt) img.alt = fi.alt;
        } else if (fallbackSrc) {
          img.src = fallbackSrc;
        }
      };

      const refresh = (variant) => {
        syncPrice();
        syncButton();
        if (variant) setImageFromVariant(variant);
      };

      syncPrice();
      syncButton();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event?.data || String(event.data.sectionId) !== String(sectionId)) return;
          refresh(event.data.variant);
        });
      }

      if (trigger && mainSubmit) {
        trigger.addEventListener('click', () => {
          if (mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true') return;

          if (isVariantPopup && productInfo) {
            const variantPopup = productInfo.querySelector('[data-product-variant-popup]');
            if (variantPopup?.openVariantPopup) {
              variantPopup.openVariantPopup();
              return;
            }
          }

          mainSubmit.click();
        });
      }

      if (!mainSubmit || !productInfo) return;

      const setBarVisible = (visible) => {
        bar.toggleAttribute('hidden', !visible);
        document.body.classList.toggle('sticky-atc-bar-visible', visible);
        if (visible) {
          syncPrice();
          syncButton();
        }
      };

      const io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;
          setBarVisible(!entry.isIntersecting);
        },
        { root: null, rootMargin: '0px 0px 0px 0px', threshold: 0 }
      );

      io.observe(mainSubmit);

      const mo = new MutationObserver(() => {
        if (bar.hasAttribute('hidden')) return;
        syncButton();
      });
      mo.observe(mainSubmit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      const mainSpan = mainSubmit.querySelector('span');
      if (mainSpan) {
        mo.observe(mainSpan, { childList: true, characterData: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductStickyAtc);
  } else {
    initProductStickyAtc();
  }
})();
